// Home page Indonesian translations

export default {
  // Hero Section
  scrollDown: "Gulir ke Bawah",
  playFullMovie: "Putar film lengkap",
  
  // Get Started Section
  innovationTitle: "Inovasi dan Keunggulan dalam Manufaktur Presisi.",
  innovationDesc1: "P.T. Eagle Industry Indonesia adalah bagian dari Eagle Industry Co., Ltd., Jepang, yang telah beroperasi selama puluhan tahun dalam menyediakan komponen berkualitas tinggi untuk berbagai industri. Kami memprioritaskan teknologi canggih, keandalan produk, dan kepuasan pelanggan untuk mendukung kebutuhan pasar global.",
  innovationDesc2: "Dengan fasilitas produksi modern di Indonesia, kami memastikan standar kualitas internasional dan pengiriman tepat waktu untuk memenuhi kebutuhan pelanggan di berbagai sektor.",
  
  // Products Section
  productsTitle: "PRODUK",
  productsDesc: "Kami menyediakan mechanical seal dan berbagai produk mekanikal untuk mobilitas darat, laut dan udara, peralatan pabrik dan peralatan manufaktur semikonduktor.",
  learnMore: "Pelajari Lebih Lanjut",
  searchByCategory: "Cari berdasarkan \nkategori",
  searchByIndustry: "Cari berdasarkan \nIndustri",
  searchByKeyword: "Cari berdasarkan \nkata kunci",
  enterKeywords: "Masukkan kata kunci produk",
  
  // Categories
  mechanicalSeals: "Mechanical Seal",
  lipSeal: "Lip Seal",
  valves: "Katup",
  floatingSeal: "Floating Seal",
  accumulators: "Akuumulator",
  waterLubricatedSternTubeSeal: "Water Lubricated Stern Tube Seal",
  waterLubricatedSternTubeBearing: "Water Lubricated Stern Tube Bearing",
  serviceEngineer: "Service Engineer",
  
  // Industries
  oilGas: "Minyak, Gas & Industri Umum",
  automobile: "Otomotif & Sepeda Motor",
  constructionAgriculture: "Konstruksi & Pertanian",
  marine: "Maritim",
  
  // Services Section
  ourServices: "Layanan Kami",
  servicesDesc: "Kami menyediakan solusi komprehensif untuk kebutuhan komponen presisi Anda.",
  customManufacturing: "Manufaktur Kustom",
  customManufacturingDesc: "Kami menawarkan solusi manufaktur kustom untuk memenuhi kebutuhan spesifik pelanggan di berbagai industri.",
  technicalSupport: "Dukungan Teknis",
  technicalSupportDesc: "Tim ahli kami menyediakan dukungan teknis untuk memastikan kinerja optimal produk kami.",
  afterSalesService: "Layanan Purnajual",
  afterSalesServiceDesc: "Kami menyediakan layanan purnajual yang andal untuk memastikan kepuasan pelanggan.",
  qualityAssurance: "Jaminan Kualitas",
  qualityAssuranceDesc: "Proses kontrol kualitas yang ketat kami memastikan semua produk memenuhi standar internasional dan spesifikasi pelanggan.",
  researchDevelopment: "Penelitian & Pengembangan",
  researchDevelopmentDesc: "Tim R&D kami terus berinovasi untuk mengembangkan solusi sealing canggih yang mengatasi tantangan industri yang terus berkembang.",
  globalSupplyChain: "Rantai Pasokan Global",
  globalSupplyChainDesc: "Kami mempertahankan jaringan pasokan global yang efisien untuk memastikan pengiriman produk tepat waktu kepada pelanggan di seluruh dunia.",
  readMore: "Baca selengkapnya",
  
  // Features Section
  floatingSeal: "Floating Seal",
  mechanicalSealFeature: "Mechanical Seal",
  lipSealFeature: "Lip Seal",
  rudder: "Kemudi",
  
  floatingSealDesc: "Floating seal presisi untuk aplikasi heavy-duty di lingkungan yang keras.",
  floatingSealFeature1: "Tahanan yang sangat baik terhadap aus dan kondisi operasi ekstrem",
  floatingSealFeature2: "Desain self-lubricating untuk kinerja dan daya tahan yang lebih baik",
  floatingSealFeature3: "Ideal untuk peralatan konstruksi, pertambangan, dan pertanian",
  floatingSealFeature4: "Konfigurasi yang dapat disesuaikan untuk memenuhi kebutuhan aplikasi spesifik",
  
  mechanicalSealDesc: "Mechanical seal kinerja tinggi yang dirancang untuk aplikasi industri yang menuntut.",
  mechanicalSealFeature1: "Direkayasa untuk daya tahan superior dan masa pakai yang diperpanjang",
  mechanicalSealFeature2: "Cocok untuk lingkungan tekanan tinggi dan suhu tinggi",
  mechanicalSealFeature3: "Tersedia dalam berbagai bahan untuk mencocokkan persyaratan aplikasi spesifik",
  
  lipSealFeature1: "Segelan berkualitas tinggi untuk aplikasi rotari dan resiprokal",
  lipSealFeature2: "Tersedia dalam berbagai bahan termasuk NBR, FKM, dan PTFE",
  lipSealFeature3: "Dirancang untuk mencegah kebocoran cairan dan kontaminasi",
  lipSealDesc: "Lip seal andal untuk aplikasi otomotif, industri, dan maritim.",
  
  rudderDesc: "Rudder seal canggih untuk kapal laut memastikan kinerja kemudi yang optimal.",
  rudderFeature1: "Direkayasa untuk daya tahan maksimal di lingkungan maritim",
  rudderFeature2: "Tahanan yang superior terhadap korosi dan kondisi air laut",
  rudderFeature3: "Dirancang untuk menjaga manuverabilitas dan keselamatan kapal"
};